var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"component":_vm.$options.name},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.data.title)+" ")]},proxy:true},{key:"body",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.data.copy))}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }